/**
 * 树穿梭框组件 (jQuery版 - 兼容IE10)
 * @namespace TreeTransfer
 * 
 * 参数说明：
 * @param {Array<{id: string, name: string, children?: Array}>} data - 树形数据
 * @param {Array<{id: string, name: string, path: Array<string>}>} value - 默认值
 * @param {Boolean} defaultExpandAll - 是否默认展开所有子节点
 * @param {Function} onChange - 值变化回调
 */
(function (window, $) {
  "use strict";

  var TreeTransfer = function (options) {
    try {
      this.emitter = window.useEmitter();
    } catch (e) {
      console.warn("请先引入 useEmitter.js 以支持事件功能");
    }

    this.options = $.extend(
      {
        // container: null, // 移除 container 参数
        data: [], // 树形数据
        value: [], // 默认值
        defaultExpandAll: false, // 是否默认展开所有子节点
        onChange: null, // 值变化回调
      },
      options,
    );

    // 创建外层 DOM
    this.$html = $('<div class="tree-transfer-container"></div>');
    this.$container = this.$html; // 保持内部使用 $container 变量名，或者直接替换为 $html
    this.treeData = [];
    this.selectedMap = {}; // 选中状态映射

    this.init();
  };

  TreeTransfer.prototype = {
    constructor: TreeTransfer,

    init: function () {
      this.debounceSearch = window.useDebounce((keyword) => this.search(keyword), 300);
      this.treeData = this.deepClone(this.options.data);
      this.render();
      this.bindEvents();

      // 如果有默认值，设置默认值
      if (this.options.value && this.options.value.length > 0) {
        this.setValue(this.options.value);
      }
    },

    // 深拷贝
    deepClone: function (obj) {
      return JSON.parse(JSON.stringify(obj));
    },

    // 渲染组件
    render: function () {
      var html =
        '<div class="tree-transfer">' +
        '<div class="tree-transfer-panel tree-transfer-left">' +
        '<div class="tree-transfer-header">' +
        '<div class="tree-transfer-search-wrapper">' +
        '<i class="iconfont icon-search2 tree-transfer-search-icon"></i>' +
        '<input type="text" class="tree-transfer-search" placeholder="请输入搜索内容">' +
        '<i class="iconfont icon-close-circle-filled tree-transfer-search-clear" style="display:none;"></i>' +
        "</div>" +
        "</div>" +
        '<div class="tree-transfer-body">' +
        '<div class="tree-transfer-tree"></div>' +
        "</div>" +
        "</div>" +
        '<div class="tree-transfer-panel tree-transfer-right">' +
        '<div class="tree-transfer-header">' +
        '<span class="tree-transfer-title">已选 <span class="tree-transfer-count">0</span></span>' +
        '<a href="javascript:;" class="tree-transfer-clear"><i class="iconfont icon-delete"></i>清空</a>' +
        "</div>" +
        '<div class="tree-transfer-body">' +
        '<div class="tree-transfer-list"></div>' +
        "</div>" +
        "</div>" +
        "</div>";

      this.$container.html(html);
      this.updateView();
    },

    // 更新视图
    updateView: function () {
      this.updateTree();
      this.updateList();
      this.updateCount();
    },

    // 更新树
    updateTree: function (keyword, matchIds, expandIds) {
      var $tree = this.$container.find(".tree-transfer-tree");
      // 如果没有传入 keyword，尝试从输入框获取（用于非搜索触发的更新）
      if (typeof keyword === 'undefined') {
          keyword = this.$container.find(".tree-transfer-search").val();
          if (keyword) {
              matchIds = {};
              expandIds = {};
              this.checkMatch(this.treeData, keyword.toLowerCase(), matchIds, expandIds);
          }
      }

      $tree.html(this.renderTree(this.treeData, [], keyword, matchIds, expandIds));
    },

    renderTree: function (data, parentPath, keyword, matchIds, expandIds) {
      var self = this;
      var html = '<ul class="tree-transfer-tree-list">';

      data.forEach(function (item) {
        // 如果有搜索关键字，且当前节点不在匹配列表中，则不渲染
        if (keyword && matchIds && !matchIds[String(item.id)]) {
            return;
        }

        var currentPath = parentPath.concat(item.id);
        var state = self.selectedMap[item.id] || { checked: false, indeterminate: false };
        var hasChildren = item.children && item.children.length > 0;

        var checkboxClass = state.checked
          ? "icon-icon-weixuanzhongxiang1"
          : state.indeterminate
            ? "icon-a-lianji11"
            : "icon-icon-weixuanzhongxiang2";
        var checkboxColor =
          state.checked || state.indeterminate ? "var(--color-primary-product)" : "#EDEDED";
        var showCheckbox = state.checked || state.indeterminate ? "show" : "";

        // 处理高亮
        var labelText = item.name;
        if (keyword) {
          if (window.PinyinMatch && window.PinyinMatch.match) {
            var matchResult = window.PinyinMatch.match(item.name, keyword);
            if (matchResult && matchResult.length === 2) {
              var start = matchResult[0];
              var end = matchResult[1];
              labelText = item.name.substring(0, start) +
                '<span class="tree-transfer-highlight">' + item.name.substring(start, end + 1) + '</span>' +
                item.name.substring(end + 1);
            }
          } else {
            var escapedKeyword = keyword.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
            var reg = new RegExp("(" + escapedKeyword + ")", "gi");
            labelText = labelText.replace(reg, '<span class="tree-transfer-highlight">$1</span>');
          }
        }

        // 默认展开所有
        var collapsedClass = self.options.defaultExpandAll ? "" : "tree-transfer-collapsed";

        // 如果有搜索关键字
        if (keyword) {
            // 只有当它是匹配路径上的父节点时才展开
            if (expandIds && expandIds[String(item.id)]) {
                collapsedClass = "";
            } else {
                collapsedClass = "tree-transfer-collapsed";
            }
        }

        // 如果当前节点被选中或部分选中，展开
        if (state.checked || state.indeterminate) {
            collapsedClass = "";
        }

        html +=
          '<li class="tree-transfer-item ' +
          collapsedClass +
          '" data-id="' +
          item.id +
          '" data-path="' +
          currentPath.join(",") +
          '">';
        html += '<div class="tree-transfer-node">';

        if (hasChildren) {
          // 注意：CSS 中 .tree-transfer-collapsed > .tree-transfer-node > .tree-transfer-expand 已经控制了旋转
          // 所以这里不需要内联样式，只需要控制 li 的 class
          html += '<i class="iconfont icon-xiala1 tree-transfer-expand" data-action="expand"></i>';
        } else {
          html += '<span class="tree-transfer-expand-placeholder"></span>';
        }

        html +=
          '<i class="iconfont ' +
          checkboxClass +
          " tree-transfer-checkbox " +
          showCheckbox +
          '" ' +
          'style="color: ' +
          checkboxColor +
          ';" data-id="' +
          item.id +
          '" data-name="' +
          item.name +
          '" data-action="checkbox"></i>';
        html += '<span class="tree-transfer-label">' + labelText + "</span>";
        html += "</div>";

        if (hasChildren) {
          html += self.renderTree(item.children, currentPath, keyword, matchIds, expandIds);
        }

        html += "</li>";
      });

      html += "</ul>";
      return html;
    },

    // 更新右侧列表
    updateList: function () {
      var $list = this.$container.find(".tree-transfer-list");
      var selectedItems = this.getSelectedItems();

      if (selectedItems.length === 0) {
        $list.html('<div class="tree-transfer-empty">暂无数据</div>');
        return;
      }

      var html = '<ul class="tree-transfer-selected-list">';
      // 数组遍历 IE10 支持 forEach
      selectedItems.forEach(function (item) {
        html +=
          '<li class="tree-transfer-selected-item" data-id="' +
          item.id +
          '" title="' +
          item.name +
          '">';
        html += '<span class="tree-transfer-selected-text">' + item.name + "</span>";
        html += "</li>";
      });
      html += "</ul>";

      $list.html(html);
    },

    // 更新计数
    updateCount: function () {
      var count = this.getSelectedItems().length;
      var $countEl = this.$container.find(".tree-transfer-count");
      if ($countEl.length > 0) {
        $countEl.text(count);
      }
    },

    getSelectedItems: function () {
      var result = [];
      this.collectSelectedItems(this.treeData, [], result);
      return result;
    },

    collectSelectedItems: function (data, parentPath, result) {
      var self = this;
      data.forEach(function (item) {
        var currentPath = parentPath.concat(item.id);
        var state = self.selectedMap[item.id];

        if (state && state.checked) {
          result.push({
            id: item.id,
            name: item.name,
            path: currentPath,
          });
        } else if (state && state.indeterminate && item.children) {
          self.collectSelectedItems(item.children, currentPath, result);
        }
      });
    },

    // 绑定事件
    bindEvents: function () {
      var self = this;
      var $container = this.$container;

      // 展开/收起
      $container.on("click", ".tree-transfer-expand", function (e) {
        e.stopPropagation();
        var $item = $(this).closest(".tree-transfer-item");
        $item.toggleClass("tree-transfer-collapsed");
      });

      // 节点点击（选中/取消选中）
      $container.on("click", ".tree-transfer-node", function (e) {
        // 如果点击的是展开图标，已经在上面的事件中处理了，这里忽略
        if ($(e.target).hasClass("tree-transfer-expand")) {
          return;
        }

        // 查找最近的 node 元素
        var $node = $(this);
        var $checkbox = $node.find(".tree-transfer-checkbox");
        if ($checkbox.length > 0) {
          var id = $checkbox.attr("data-id");
          var name = $checkbox.attr("data-name");
          var $item = $node.closest(".tree-transfer-item");
          var path = $item.attr("data-path").split(",");

          self.toggleCheck(id, name, path);
        }
      });

      // 鼠标悬停显示checkbox
      // $container.on('mouseover', '.tree-transfer-node', function(e) {
      //     var $node = $(this);
      //     var $checkbox = $node.find('.tree-transfer-checkbox');
      //     if ($checkbox.length > 0 && !$checkbox.hasClass('show')) {
      //         $checkbox.css('visibility', 'visible');
      //     }
      // });

      // $container.on('mouseout', '.tree-transfer-node', function(e) {
      //     var $node = $(this);
      //     var $checkbox = $node.find('.tree-transfer-checkbox');
      //     if ($checkbox.length > 0 && !$checkbox.hasClass('show')) {
      //         $checkbox.css('visibility', 'hidden');
      //     }
      // });

      // 移除按钮（点击列表项移除）
      $container.on("click", ".tree-transfer-selected-item", function (e) {
        var $item = $(this);
        var id = $item.attr("data-id");
        self.removeItem(id);
      });

      // 清空
      $container.on("click", ".tree-transfer-clear", function () {
        self.clear();
      });

      // 搜索
      $container.on("input propertychange", ".tree-transfer-search", function (e) {
        var val = $(this).val();
        var $clearBtn = $container.find(".tree-transfer-search-clear");
        if (val) {
          $clearBtn.show();
        } else {
          $clearBtn.hide();
        }

        self.debounceSearch(val);
      });

      // 清除搜索
      $container.on("click", ".tree-transfer-search-clear", function () {
        var $input = $container.find(".tree-transfer-search");
        $input.val("");
        $(this).hide();
        self.debounceSearch("");
      });

      // 搜索框聚焦/失焦样式
      $container.on("focus", ".tree-transfer-search", function () {
        $container.find(".tree-transfer-search-icon").addClass("active");
      });

      $container.on("blur", ".tree-transfer-search", function () {
        $container.find(".tree-transfer-search-icon").removeClass("active");
      });
    },

    toggleCheck: function (id, name, path) {
      var state = this.selectedMap[id] || { checked: false, indeterminate: false };
      state.checked = !state.checked;
      state.indeterminate = false;
      state.name = name;
      state.path = path;
      this.selectedMap[id] = state;

      // 更新子节点
      this.updateChildren(id, state.checked);

      // 更新父节点
      this.updateParents(path);

      this.updateView();
      this.triggerChange();
    },

    updateChildren: function (parentId, checked) {
      var self = this;
      var node = this.findNode(parentId, this.treeData);
      if (node && node.children) {
        node.children.forEach(function (child) {
          var childState = self.selectedMap[child.id] || {};
          childState.checked = checked;
          childState.indeterminate = false;
          childState.name = child.name;
          self.selectedMap[child.id] = childState;
          self.updateChildren(child.id, checked);
        });
      }
    },

    updateParents: function (path) {
      for (var i = path.length - 2; i >= 0; i--) {
        var parentId = path[i];
        var parentNode = this.findNode(parentId, this.treeData);

        if (parentNode && parentNode.children) {
          var checkedCount = 0;
          var totalCount = parentNode.children.length;

          for (var j = 0; j < parentNode.children.length; j++) {
            var childState = this.selectedMap[parentNode.children[j].id];
            if (childState && childState.checked) {
              checkedCount++;
            } else if (childState && childState.indeterminate) {
              checkedCount += 0.5;
            }
          }

          var parentState = this.selectedMap[parentId] || {};
          parentState.name = parentNode.name;
          if (checkedCount === 0) {
            parentState.checked = false;
            parentState.indeterminate = false;
          } else if (checkedCount === totalCount) {
            parentState.checked = true;
            parentState.indeterminate = false;
          } else {
            parentState.checked = false;
            parentState.indeterminate = true;
          }
          this.selectedMap[parentId] = parentState;
        }
      }
    },

    findNode: function (id, data) {
      var self = this;
      for (var i = 0; i < data.length; i++) {
        if (data[i].id == id) {
          return data[i];
        }
        if (data[i].children) {
          var found = self.findNode(id, data[i].children);
          if (found) return found;
        }
      }
      return null;
    },

    removeItem: function (id) {
      delete this.selectedMap[id];

      // 清除子节点状态
      var node = this.findNode(id, this.treeData);
      if (node) {
        this.clearNodeState(node);
      }

      // 更新父节点状态
      var $item = this.$container.find('.tree-transfer-item[data-id="' + id + '"]');
      if ($item.length > 0) {
        var path = $item.attr("data-path").split(",");
        this.updateParents(path);
      }

      this.updateCheckboxDom(id, { checked: false, indeterminate: false });
      this.updateList();
      this.updateCount();
      this.triggerChange();
    },

    clearNodeState: function (node) {
      var self = this;
      delete this.selectedMap[node.id];
      this.updateCheckboxDom(node.id, { checked: false, indeterminate: false });
      if (node.children) {
        node.children.forEach(function (child) {
          self.clearNodeState(child);
        });
      }
    },

    clear: function (notTrigger) {
      this.selectedMap = {};
      // 更新所有 checkbox 样式
      var $checkboxes = this.$container.find(".tree-transfer-checkbox");
      $checkboxes
        .removeClass("icon-icon-weixuanzhongxiang1 icon-a-lianji11 show")
        .addClass("icon-icon-weixuanzhongxiang2")
        .css("color", "#EDEDED");

      this.updateList();
      this.updateCount();
      !notTrigger && this.triggerChange();
    },

    search: function (keyword) {
      if (!keyword) {
        this.updateTree();
        return;
      }

      var matchIds = {};
      var expandIds = {};
      this.checkMatch(this.treeData, keyword.toLowerCase(), matchIds, expandIds);

      // 重新渲染树，带上关键字和匹配状态
      this.updateTree(keyword, matchIds, expandIds);
    },

    checkMatch: function(data, keyword, matchIds, expandIds) {
        var self = this;
        var hasMatch = false;

        data.forEach(function(item) {
            var isSelfMatch = false;
            if (window.PinyinMatch && window.PinyinMatch.match) {
                isSelfMatch = !!window.PinyinMatch.match(item.name, keyword);
            } else {
                isSelfMatch = item.name.toLowerCase().indexOf(keyword) !== -1;
            }
            var isChildMatch = false;

            if (item.children && item.children.length > 0) {
                isChildMatch = self.checkMatch(item.children, keyword, matchIds, expandIds);
            }

            if (isSelfMatch || isChildMatch) {
                matchIds[String(item.id)] = true;
                hasMatch = true;
            }

            if (isChildMatch) {
                expandIds[String(item.id)] = true;
            }
        });

        return hasMatch;
    },

    collectMatchIds: function (data, keyword, parentIds, matchIds) {
      var self = this;
      // 数组遍历 IE10 支持 forEach
      data.forEach(function (item) {
        var currentIds = parentIds.concat(item.id);
        var isMatch = item.name.toLowerCase().indexOf(keyword) !== -1;

        if (isMatch) {
          // 如果当前节点匹配，它和它的所有祖先都应该显示
          currentIds.forEach(function (id) {
            matchIds[String(id)] = true;
          });
          // 它的所有子节点也应该显示吗？通常是的
          self.addAllChildrenIds(item, matchIds);
        }

        if (item.children) {
          self.collectMatchIds(item.children, keyword, currentIds, matchIds);
        }
      });
    },

    addAllChildrenIds: function (node, matchIds) {
      var self = this;
      matchIds[String(node.id)] = true;
      if (node.children) {
        node.children.forEach(function (child) {
          self.addAllChildrenIds(child, matchIds);
        });
      }
    },

    toggleCheck: function (id, name, path) {
      var state = this.selectedMap[id] || { checked: false, indeterminate: false };
      state.checked = !state.checked;
      state.indeterminate = false;
      state.name = name;
      state.path = path;
      this.selectedMap[id] = state;

      this.updateCheckboxDom(id, state);

      // 更新子节点
      this.updateChildren(id, state.checked);

      // 更新父节点
      this.updateParents(path);

      this.updateList();
      this.updateCount();
      this.triggerChange();
    },

    updateChildren: function (parentId, checked) {
      var self = this;
      var node = this.findNode(parentId, this.treeData);
      if (node && node.children) {
        node.children.forEach(function (child) {
          var childState = self.selectedMap[child.id] || {};
          childState.checked = checked;
          childState.indeterminate = false;
          childState.name = child.name;
          self.selectedMap[child.id] = childState;

          self.updateCheckboxDom(child.id, childState);

          self.updateChildren(child.id, checked);
        });
      }
    },

    updateParents: function (path) {
      for (var i = path.length - 2; i >= 0; i--) {
        var parentId = path[i];
        var parentNode = this.findNode(parentId, this.treeData);

        if (parentNode && parentNode.children) {
          var checkedCount = 0;
          var totalCount = parentNode.children.length;

          for (var j = 0; j < parentNode.children.length; j++) {
            var childState = this.selectedMap[parentNode.children[j].id];
            if (childState && childState.checked) {
              checkedCount++;
            } else if (childState && childState.indeterminate) {
              checkedCount += 0.5;
            }
          }

          var parentState = this.selectedMap[parentId] || {};
          parentState.name = parentNode.name;
          if (checkedCount === 0) {
            parentState.checked = false;
            parentState.indeterminate = false;
          } else if (checkedCount === totalCount) {
            parentState.checked = true;
            parentState.indeterminate = false;
          } else {
            parentState.checked = false;
            parentState.indeterminate = true;
          }
          this.selectedMap[parentId] = parentState;
          this.updateCheckboxDom(parentId, parentState);
        }
      }
    },

    updateCheckboxDom: function (id, state) {
      var $checkbox = this.$container.find(
        '.tree-transfer-item[data-id="' + id + '"] > .tree-transfer-node > .tree-transfer-checkbox',
      );
      if ($checkbox.length > 0) {
        $checkbox.removeClass(
          "icon-icon-weixuanzhongxiang1 icon-icon-weixuanzhongxiang2 icon-a-lianji11",
        );

        if (state.checked) {
          $checkbox
            .addClass("icon-icon-weixuanzhongxiang1 show")
            .css("color", "var(--color-primary-product)");
        } else if (state.indeterminate) {
          $checkbox.addClass("icon-a-lianji11 show").css("color", "var(--color-primary-product)");
        } else {
          $checkbox
            .addClass("icon-icon-weixuanzhongxiang2")
            .removeClass("show")
            .css("color", "#EDEDED");
        }
      }
    },

    triggerChange: function () {
      if (typeof this.options.onChange === "function") {
        this.options.onChange(this.getValue());
      }

      if (this.emitter) {
        this.emitter.emit("change", this.getValue());
      }
    },

    findPath: function (id, data, currentPath) {
      var self = this;
      for (var i = 0; i < data.length; i++) {
        var path = currentPath.concat(data[i].id);
        if (data[i].id == id) {
          return path;
        }
        if (data[i].children) {
          var found = self.findPath(id, data[i].children, path);
          if (found) return found;
        }
      }
      return null;
    },

    setValue: function (values) {
      var self = this;

      // 清空所有选中状态
      this.clear(true); // true 表示不触发 change 事件

      if (!values || values.length === 0) {
        return;
      }

      // 根据传入的值设置选中状态
      // 数组遍历 IE10 支持 forEach
      values.forEach(function (item) {
        var node = self.findNode(item.id, self.treeData);
        if (node) {
          // 自动计算 path，忽略传入的 path
          var path = self.findPath(item.id, self.treeData, []);

          self.selectedMap[item.id] = {
            checked: true,
            indeterminate: false,
            path: path,
            name: node.name,
          };

          // 更新子节点
          self.updateChildren(item.id, true);

          // 更新父节点
          if (path) {
            self.updateParents(path);
          }
        }
      });

      // 重新渲染树以应用展开状态
      this.updateTree();

      this.updateList();
      this.updateCount();
    },

    /**
     * 更新数据
     * @param {Array} data 新的树形数据
     * @param {Boolean} keepSelected 是否保留当前选中状态
     */
    updateData: function (data, keepSelected) {
      var currentValues = [];
      if (keepSelected) {
        currentValues = this.getValue();
      }

      this.treeData = this.deepClone(data);
      this.options.data = data;

      // 重新渲染树结构
      // 注意：这里可能需要完全重新渲染，包括搜索框等，或者只更新树部分
      // 考虑到 renderTree 只返回 ul，我们需要更新 .tree-transfer-tree 的内容
      // 但如果数据变了，之前的搜索关键字可能也不适用了，建议清空搜索
      this.$container.find(".tree-transfer-search").val("");
      this.$container.find(".tree-transfer-search-clear").hide();
      this.updateTree();

      if (keepSelected && currentValues.length > 0) {
        this.setValue(currentValues);
      } else {
        this.clear(true);
      }
    },

    getValue: function () {
      var result = [];
      this.collectSelectedItems(this.treeData, [], result);
      return result;
    },

    destroy: function () {
      this.$html.remove();
      this.treeData = [];
      this.selectedMap = {};
    },
  };

  // 暴露到全局
  window.TreeTransfer = TreeTransfer;
})(window, jQuery);
